import { render } from "./ChulhaAssignNew1.vue?vue&type=template&id=723c2253&scoped=true"
import script from "./ChulhaAssignNew1.vue?vue&type=script&lang=js"
export * from "./ChulhaAssignNew1.vue?vue&type=script&lang=js"

import "./ChulhaAssignNew1.vue?vue&type=style&index=0&id=723c2253&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-723c2253"

export default script